import React, { useState } from 'react';

import { AllergensDisclaimer } from 'features/menu/components/product-detail/product-nutrition-information/allergens-disclaimer';
import { NutritionModal } from 'features/menu/components/product-detail/product-nutrition-information/nutrition-modal';
import {
  NutritionInformationContainer,
  NutritionInformationTitle,
  NutritionInformationWrapper,
} from 'features/menu/components/product-detail/product-nutrition-information/styled';

import LegalDisclaimers from 'components/legal-disclaimers';
import { TextWithArrowButton } from 'components/text-with-arrow-button';
import { mergeCatalogItemAllergens } from 'experiments/deeplinks-flow-feature/treatment/features/menu/components/menu-catalog-preview/get-catalog-included';
import { t } from 'state/intl/translations';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { ILocalizedMenuEntry } from 'state/unified-menu/types';

interface IProductNutritionInformationProps {
  selectedProduct: ILocalizedMenuEntry;
  /**
   * Catalog-preview products that represent the current item, picker, or combo
   * selection. Use them for allergens and the nutrition modal.
   */
  nutritionItems?: ILocalizedMenuEntry[];
}

export const ProductNutritionInformation: React.FC<IProductNutritionInformationProps> = ({
  selectedProduct,
  nutritionItems,
}) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const enableAllergensDisclaimer = useFlag(LaunchDarklyFlag.ENABLE_ALLERGENS_DISCLAIMER);

  const hasItemNutrition = Boolean(nutritionItems?.some(item => item.nutrition));
  const hasProductNutrition = Boolean(selectedProduct.nutrition);
  if (!hasItemNutrition && !hasProductNutrition) {
    return null;
  }

  const allergens =
    (nutritionItems?.length ? mergeCatalogItemAllergens(nutritionItems) : undefined) ??
    selectedProduct.nutrition?.allergens;

  return (
    <>
      <NutritionInformationWrapper focusable>
        <NutritionInformationContainer>
          <TextWithArrowButton
            messageId="nutritionalInformationAndAllergen"
            onPress={() => setIsModalOpen(true)}
          />
        </NutritionInformationContainer>

        <NutritionInformationTitle>{t('information')}</NutritionInformationTitle>

        {enableAllergensDisclaimer && allergens ? (
          <AllergensDisclaimer allergens={allergens} />
        ) : null}

        <LegalDisclaimers />
      </NutritionInformationWrapper>

      {isModalOpen && (
        <NutritionModal
          onDismiss={() => setIsModalOpen(false)}
          selectedProduct={selectedProduct}
          nutritionItems={nutritionItems}
        />
      )}
    </>
  );
};
